'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouterRedux = require('react-router-redux');

var _personal = require('redux/actions/personal');

var _payment = require('redux/actions/payment');

var _error = require('redux/actions/error');

var _constants = require('redux/constants');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _helpers = require('helpers');

var _utils = require('helpers/utils');

var _PaymentStatus = require('helpers/Order/PaymentStatus');

var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OrderList: {
        displayName: 'OrderList'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/OrderList/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OrderList = _wrapComponent('OrderList')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;


        var limit = parseInt(location.query.limit, 10) || _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT,
            page = parseInt(location.query.page, 10) || 1;

        if (limit > _constants.CatalogNumericConstants.MAX_LIMIT) {
            limit = _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
        }
        if (page > _constants.CatalogNumericConstants.MAX_PAGE) {
            page = 1;
        }
        return dispatch((0, _personal.getPersonalOrderList)(page, limit));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        ordersList: state.personal_order_list,
        user: state.auth.user,
        lang: state.lang
    };
}, {
    pushState: _reactRouterRedux.push,
    rePaymentByOrder: _payment.rePaymentByOrder,
    throwAlertAction: _error.error
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(OrderList, _Component);

    function OrderList() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, OrderList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = OrderList.__proto__ || (0, _getPrototypeOf2.default)(OrderList)).call.apply(_ref2, [this].concat(args))), _this), _this.onPay = function (_ref3) {
            var id = _ref3.id,
                payment_in_id = _ref3.payment_in_id,
                paymentStatus = _ref3.paymentStatus;

            var paymentStatusHelper = new _PaymentStatus2.default(paymentStatus.id);

            if (paymentStatusHelper.isCanceled()) {
                _this.props.throwAlertAction(_this.props.lang[paymentStatus.lang_data]);
            } else if (paymentStatusHelper.isOutdated) {
                _this.props.rePaymentByOrder(id, function (newOrder) {
                    _this.props.pushState('/create-order/' + newOrder.order_id);
                });
            } else {
                _this.props.pushState('/create-order/' + id);
            }
        }, _this.handleChangePage = function (page, limit) {
            _this.props.pushState('/personal/order-list?limit=' + limit + '&page=' + page);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(OrderList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$ordersList = this.props.ordersList,
                limit = _props$ordersList.limit,
                activePage = _props$ordersList.activePage;

            history.replaceState(null, null, '/personal/order-list?limit=' + limit + '&page=' + activePage);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                lang = _props.lang;


            var View = _helpers.ThemeHelper.getViewForContainer('OrderList', null, { folderName: 'Personal/OrderList' });
            var _props$ordersList2 = this.props.ordersList,
                activePage = _props$ordersList2.activePage,
                count = _props$ordersList2.count,
                limit = _props$ordersList2.limit,
                orders = _props$ordersList2.orders;


            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactHelmet2.default, { title: lang['store.helmet.order_list'] }),
                user ? _react3.default.createElement(View, {
                    activePage: activePage,
                    count: count,
                    handleChangePage: this.handleChangePage,
                    limit: limit,
                    onPay: this.onPay,
                    orders: orders
                }) : null
            );
        }
    }]);
    return OrderList;
}(_react2.Component), _class2.propTypes = {
    orders: _react2.PropTypes.array,
    pushState: _react2.PropTypes.func.isRequired,
    rePaymentByOrder: _react2.PropTypes.func.isRequired,
    user: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _temp2)) || _class) || _class));

exports.default = OrderList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/OrderList/index.jsx
// module id = 1832
// module chunks = 0